import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { AdminUnitPropertyRepository } from './domain/AdminUnitPropertyRepository'

import {
  AdminUnitPropertyListCriteria,
  AdminUnitPropertyListItem,
  AdminUnitPropertyView,
} from '../../contracts/treatment'
import {
  AdminUnitPropertyModifyRequest,
  AdminUnitPropertyRequest,
} from '../../contracts/treatment/AdminUnitPropertyRequest'
import { AxiosErrorHandler, SupernovaPagedBody } from '../../foundation'

export class AdminApiUnitProperty implements AdminUnitPropertyRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getList = async (
    criteria: AdminUnitPropertyListCriteria,
  ): Promise<SupernovaPagedBody<AdminUnitPropertyListItem[]>> => {
    const config: AxiosRequestConfig<AdminUnitPropertyListCriteria> = {
      url: '/treatment/property/admin/query/unit-property-list/process',
      method: 'post',
      data: {
        pagination: criteria.pagination,
      },
    }

    try {
      const { data } = await this.axios.request<SupernovaPagedBody<AdminUnitPropertyListItem[]>>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  getById = async (id: string): Promise<AdminUnitPropertyView> => {
    const config: AxiosRequestConfig<{ id: string }> = {
      url: '/treatment/property/admin/query/unit-property/process',
      method: 'post',
      data: { id },
    }

    try {
      const { data } = await this.axios.request<AdminUnitPropertyView>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  createProperty = async (command: AdminUnitPropertyRequest): Promise<void> => {
    const config: AxiosRequestConfig<AdminUnitPropertyRequest> = {
      url: '/treatment/property/admin/command/create-unit-property/execute',
      method: 'post',
      data: command,
    }

    try {
      await this.axios.request<void>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  modifyProperty = async (command: AdminUnitPropertyModifyRequest): Promise<void> => {
    const config: AxiosRequestConfig<AdminUnitPropertyModifyRequest> = {
      url: '/treatment/property/admin/command/modify-unit-property/execute',
      method: 'post',
      data: command,
    }

    try {
      await this.axios.request<void>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  enableProperty = async (id: string): Promise<void> => {
    const config: AxiosRequestConfig<{ id: string }> = {
      url: '/treatment/property/admin/command/enable-unit-property/execute',
      method: 'post',
      data: { id },
    }

    try {
      await this.axios.request<void>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  disableProperty = async (id: string): Promise<void> => {
    const config: AxiosRequestConfig<{ id: string }> = {
      url: '/treatment/property/admin/command/disable-unit-property/execute',
      method: 'post',
      data: { id },
    }

    try {
      await this.axios.request<void>(config)
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
